import React from 'react';
import { CardSubtitle } from 'reactstrap';
import { UncontrolledTable } from '~/components';
import { TableFilterDateRange, TableFilterIdentitySource } from '~/components/Filters';
import usePatient from '~/utils/patient/hook';
import { MatchStatus } from '~/utils/const/identity';

const Vision = () => {
  const [, { sacwisPersonId: sacwisId }] = usePatient();

  return (
    <>
      <CardSubtitle tag="h5" className="m-3">
        Vision
      </CardSubtitle>

      <UncontrolledTable
        name="vision"
        className="mx-4"
        endpoint={{
          url: 'data/public/list-view-cs-tbl-visionhearingscreen',
          params: {
            screentype: 'vision',
            sacwis_id: sacwisId,
            match_status_id: MatchStatus.Approved,
            'all-data': '1',
          },
        }}
        defaultSorted={[{ id: 'dispname', desc: true }]}
        columns={[{
          id: 'dispname',
          Header: 'Exam Details',
          accessor: 'attributes.dispname',
        },
        {
          id: 'measvalue',
          Header: 'Results',
          accessor: 'attributes.measvalue',
        },
        {
          id: 'recordedtimeTs__>>',
          Header: 'Date',
          accessor: 'attributes.recordedtimeTs',
          cellType: 'date',
          Filter: d => <TableFilterDateRange {...d} />,
        },
        {
          id: 'sourceDescription',
          Header: 'Reporting Healthcare Insitution',
          accessor: 'attributes.sourceDescription',
          Filter: d => <TableFilterIdentitySource {...d} />,
        }]}
      />

      <p className="mt-3 text-muted">
        <em>**An HOTV Chart vision screen is considered to be normal when:</em>
      </p>

      <ul className="text-muted">
        <li>
          A child less than 5 years old has acuity of 20/40 or better and &gt; 2
          line difference between eyes
        </li>

        <li>
          A chlid 6 years or older has acuity of 20/30 or better and &gt; 2 line
          difference between eyes
        </li>

        <li>
          A spot vision screen is considered to be normal when the result is all
          measurements in range
        </li>
      </ul>
    </>
  );
};

export default Vision;
